import styled from 'styled-components';

const StyledDragWrapper = styled.div`
  border: 2px dotted
    ${props =>
      props.dragging
        ? props.theme.colors.secondary
        : props.theme.colors.light_darker_1};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${props => props.theme.spacing.small};
  padding: ${props => props.theme.spacing.small} 0;
  border-radius: ${props => props.theme.border_radius.standard};
  height: 120px;
`;

const StyledDragFileName = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.small};
`;

export { StyledDragWrapper, StyledDragFileName };
